import React, {Component} from 'react';
import './CartItemDetailsExpandView.css';
import {FormattedMessage} from "react-intl";
import OrderType1ExpandedView from '../../CartItem/CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView';
import OrderType3ExpandedView from '../../CartItem/CartItemDetails/OrderType3ExpandedView/OrderType3ExpandedView';
import more from "../../../../../assets/img/icons8-double-down-24.png";
import less from "../../../../../assets/img/icons8-double-up-25.png";

const MoreLessLink = (props) => {
    if (props.showMore) {
        return (<small>
            <a className="more-less-link" onClick={props.moreLessLinkCLicked}>
                {/*<FormattedMessage id="app.cart.less-link"
                                  defaultMessage="Less..."
                                  description=""/>*/}
                <img src={less}/>
            </a>
        </small>);
    } else {
        return (<small>
            <a className="more-less-link" onClick={props.moreLessLinkCLicked}>
                {/*<FormattedMessage id="app.cart.more-link"
                                  defaultMessage="More..."
                                  description=""/>*/}
                <img src={more}/></a>
        </small>);
    }
};

const ItemDetailsExpandView = (props) => {
    if (props.showMore) {
        let pcbParams = props.itemDetails.quotation.pcbParam;
        if (props.itemDetails.quotation.orderType === 1) {
            return (
                <OrderType1ExpandedView
                    pcbParams={pcbParams}
                    itemDetails={props.itemDetails}/>
            )
        } else if (props.itemDetails.quotation.orderType === 2) {
            return (
                <div>
                    <OrderType1ExpandedView
                        pcbParams={pcbParams}
                        itemDetails={props.itemDetails}/>
                    <OrderType3ExpandedView
                        smtStencilParams={props.itemDetails.quotation.stencilParam}
                        itemDetails={props.itemDetails}/>
                </div>
            )
        } else if (props.itemDetails.quotation.orderType === 3) {
            return (
                <OrderType3ExpandedView
                    smtStencilParams={props.itemDetails.quotation.stencilParam}
                    itemDetails={props.itemDetails}/>
            )
        }


    }
    return null;
};

class CartItemDetailsExpandView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetails: false
        };
        this.moreLessLinkCLicked = this.moreLessLinkCLicked.bind(this);
    }

    moreLessLinkCLicked = () => {
        let showDetails = !this.state.showDetails;
        this.setState( { showDetails } );
    };

    render() {
        return (
            <div className="move-up-div">
                <ItemDetailsExpandView showMore = {this.state.showDetails}
                                       itemDetails = {this.props.itemDetails}/>
                <div className="more-less-div">
                    <div className="spacer"></div>
                    <div className="spacer"></div>
                    <div className="spacer"></div>
                    <MoreLessLink showMore={this.state.showDetails}
                                  moreLessLinkCLicked={this.moreLessLinkCLicked}/>
                </div>



            </div>
        );
    }

}

export default CartItemDetailsExpandView;




// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartItem/CartItemDetails/CartItemDetailsExpandView.js